import { render, staticRenderFns } from "./TableUserGroupUsers.vue?vue&type=template&id=4bd4e105&"
import script from "./TableUserGroupUsers.vue?vue&type=script&lang=js&"
export * from "./TableUserGroupUsers.vue?vue&type=script&lang=js&"
import style0 from "./TableUserGroupUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports